import { z } from "zod";
export const IntervalMark = z.enum(["skip baseline", "incorrect fuel", "offline", "use unisea"]);
//# sourceMappingURL=intervalMark.js.map